import Errors from '@/const/errors'

function calculateCheckDigit(input) {
  const length = input.length
  let sum = 0
  const evenFactor = length % 2 === 0 ? 1 : 3
  const oddFactor = length % 2 === 0 ? 3 : 1
  for (let i = 0; i < length; i++) {
    const digit = parseInt(input[i])
    if (i % 2 === 0) {
      sum += digit * evenFactor
    } else {
      sum += digit * oddFactor
    }
  }
  let result = 10 - (sum % 10)
  if (result === 10) {
    result = 0
  }
  return result
}

function throwError(code, suggestion = null) {
  const error = new Error('Invalid GTIN')
  error.code = code
  error.suggestion = suggestion
  throw error
}

export const validateGtin = {
  methods: {
    validateGtin(gtin) {
      if (!/^\d*$/.test(gtin)) {
        throwError(Errors.NON_NUMERIC)
      }
      const length = gtin.length
      if (length < 7) {
        // Also suggest +=check digit for gtin8
        throwError(Errors.TOO_SHORT)
      } else if (length > 14) {
        throwError(Errors.TOO_LONG)
      }
      const startsWithZero = gtin[0] === '0'
      if (length === 14 && !startsWithZero) {
        throwError(Errors.INVALID_INDICATOR_DIGIT)
      }
      const input = gtin.substring(0, length - 1)
      const checkDigit = Number(gtin[length - 1])
      const correctCheckDigit = calculateCheckDigit(input)
      if (correctCheckDigit !== checkDigit) {
        var suggestion = input + correctCheckDigit
        if (
          length === 7 ||
          length === 12 ||
          (length === 13 && startsWithZero)
        ) {
          suggestion = gtin + calculateCheckDigit(gtin)
        }
        throwError(Errors.INVALID_CHECK_DIGIT, suggestion)
      }
      console.log('GTIN passed validation', gtin)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/validateGtin.js